// notify slider 
// $(document).ready(function () {
//     $(".notify_slider").slick({
//       dots: false,  
//     arrows: false,    
//     infinite: true,    
//     autoplay: true,     
//     slidesToShow: 1,  
//     slidesToScroll: 1,
//     autoplaySpeed: 4000,
//     speed: 8000,  
//     cssEase: 'linear',
//     variableWidth: true

//     });
// })
// $(window).on('load', function () {
//   $(".notify_slider").slick({
//     dots: false,
//     arrows: false,
//     infinite: true,
//     autoplay: true,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     autoplaySpeed: 4000,
//     speed: 8000, 
//     cssEase: 'linear',
//     variableWidth: true,
//     lazyLoad: 'ondemand'
//   });
// });

// sticky-header
// on scroll add class
$(document).ready(function () {
    $(window).scroll(function () {
        if ($(document).scrollTop() > 10) {
            $("body").addClass("sticky_hdr");
        } else {
            $("body").removeClass("sticky_hdr");
        }
    });
});

$(document).ready(function() {
    $(".bnnr_sliders").slick({
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 2000,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        appendDots: $('#custom-dots')
    })
});

// stiky sliders 
$(document).ready(function() {
    if ($(window).width() < 992) {
        $('.stky_sliders').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            responsive: [{
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 481,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    },
                },

                {
                    breakpoint: 376,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    },
                },
            ],
        });
    }
});

let SC = ScrollMoo({
    ".wcl_txt": {
        // markers: true,
        indicatorStart: 60,
        indicatorEnd: 20,
        keyframes: {
            transform: {
                translateY: {
                    0: "0px",
                    25: "-30px",
                    50: "-100px",
                    100: "-280px"
                }
            }
        }
    },
    ".wel_img_con": {
        // markers: true,
        indicatorStart: 90,
        indicatorEnd: 20,
        keyframes: {
            transform: {
                translateY: {
                    0: "0px",
                    25: "-170px",
                    50: "-340px",
                    100: "-680px"
                }
            }
        }
    },

    ".plate_wrap": {
        // markers: true,
        indicatorStart: 90,
        indicatorEnd: 20,
        keyframes: {
            transform: {
                translateY: {
                    0: "0px",
                    25: "-100px",
                    50: "-300px",

                    100: "-1040px"
                }
            }
        }
    },

    ".spoons_imgs": {
        // markers: true,
        indicatorStart: 90,
        indicatorEnd: 80,
        keyframes: {
            transform: {
                translateY: {
                    0: "0px",
                    25: "-350px",
                    50: "-540px",
                    100: "-740px"
                }
            }
        }
    },
});


// search bar toggle 
let search_icon = document.querySelector(".srch_txt").addEventListener("click", (e) => {
    let searchInput = document.querySelector(".searchInput");
    let body = document.body;
    // console.log(searchInput.classList.value);
    if (searchInput.classList.value == "searchInput toggleSearch" || searchInput.classList.value == "searchInput toggleSearch active") {
        searchInput.classList.remove("toggleSearch");
        searchInput.classList.remove("active");
        body.classList.remove("search-open");
    } else {
        searchInput.classList.add("toggleSearch");
        let searchTxt = document.querySelector(".searchTxt").value = "";
        body.classList.add("search-open");
    }

})

let suggestions = [
    "Channel",
    "CodingLab",
    "CodingNepal",
    "YouTube",
    "YouTuber",
    "YouTube Channel",
    "Blogger",
    "Bollywood",
    "Vlogger",
    "Vechiles",
    "Facebook",
    "Freelancer",
    "Facebook Page",
    "Designer",
    "Developer",
    "Web Designer",
    "Web Developer",
    "Login Form in HTML & CSS",
    "How to learn HTML & CSS",
    "How to learn JavaScript",
    "How to became Freelancer",
    "How to became Web Designer",
    "How to start Gaming Channel",
    "How to start YouTube Channel",
    "What does HTML stands for?",
    "What does CSS stands for?",
];

// getting all required elements
const searchInput = document.querySelector(".searchInput");
const input = searchInput.querySelector("input");
const resultBox = searchInput.querySelector(".resultBox");
const icon = searchInput.querySelector(".icon");
let linkTag = searchInput.querySelector("a");
let webLink;

// if user press any key and release
input.onkeyup = (e) => {
    let userData = e.target.value; //user enetered data
    let emptyArray = [];
    if (userData) {
        emptyArray = suggestions.filter((data) => {
            //filtering array value and user characters to lowercase and return only those words which are start with user enetered chars
            return data.toLocaleLowerCase().startsWith(userData.toLocaleLowerCase());
        });
        emptyArray = emptyArray.map((data) => {
            // passing return data inside li tag
            return data = '<li>' + data + '</li>';
        });
        searchInput.classList.add("active"); //show autocomplete box
        showSuggestions(emptyArray);
        let allList = resultBox.querySelectorAll("li");
        for (let i = 0; i < allList.length; i++) {
            //adding onclick attribute in all li tag
            allList[i].setAttribute("onclick", "select(this)");
        }
    } else {
        searchInput.classList.remove("active"); //hide autocomplete box
    }
}

function showSuggestions(list) {
    let listData;
    if (!list.length) {
        userValue = inputBox.value;
        listData = '<li>' + userValue + '</li>';
    } else {
        listData = list.join('');
    }
    resultBox.innerHTML = listData;
}

function select(data) {
    input.value = data.textContent;
    searchInput.classList.remove("active"); // Hide suggestions
}


document.querySelector(".fa-times").addEventListener("click", () => {
    let searchInput = document.querySelector(".searchInput");
    document.body.classList.remove("search-open");
    searchInput.classList.remove("toggleSearch", "active");
});

// Responsive Mega Menu

// document.addEventListener('DOMContentLoaded', () => {
//     let menu_Lists = document.querySelectorAll(".innr_menu");
//     let activeMenu = null; // To keep track of the currently active menu item

//     menu_Lists.forEach((menu) => {
//         menu.addEventListener("click", (e) => {
//             e.preventDefault()
//             // If there's an active menu item and it's not the one we just clicked,
//             // remove the 'active' class from it.
//             if (activeMenu && activeMenu !== menu) {
//                 activeMenu.classList.remove("active");
//             }

//             // Toggle the 'active' class on the clicked menu item
//             menu.classList.toggle("active");

//             // Update activeMenu to the currently clicked one, or null if it's now inactive
//             if (menu.classList.contains("active")) {
//                 activeMenu = menu;
//             } else {
//                 activeMenu = null;
//             }
//         });
//     });

//     let drop_Sections = document.querySelectorAll(".drop_section"); // Use querySelectorAll for potentially multiple
//                                                                    // If you only ever have one, querySelector is fine.

//     drop_Sections.forEach((dropSection) => { // Loop through each drop_section if there are multiple
//         dropSection.addEventListener("click", (e) => {
//             e.preventDefault(); // Prevent default link behavior (if drop_section is a link or contains one)

//             // Toggle the 'active_drop' class on the *specific* .drop_section that was clicked
//             dropSection.classList.toggle("active_drop");

//             // If you want only one .drop_section to be active at a time, you'd add similar logic:
//             /*
//             if (drop_activeMenu && drop_activeMenu !== dropSection) {
//                 drop_activeMenu.classList.remove("active_drop");
//             }
//             if (dropSection.classList.contains("active_drop")) {
//                 drop_activeMenu = dropSection;
//             } else {
//                 drop_activeMenu = null;
//             }
//             */
//             // But based on your request, it seems like you just want to toggle on click.
//         });
//     });

// });

document.addEventListener('DOMContentLoaded', () => {
    const menuItems = document.querySelectorAll('.menuiteam h6');

    menuItems.forEach(h6 => {
        h6.addEventListener('click', function(e) {
            // Define the breakpoint for desktop mode
            const desktopBreakpoint = 991; // Pixels

            // Only prevent default if the screen width is less than the desktop breakpoint
            if (window.innerWidth <= desktopBreakpoint) {
                e.preventDefault();
            }
            // Get the parent .menuiteam of the clicked h6
            const parentMenuItem = this.closest('.menuiteam');

            // Find the currently active menu item and its ul
            const currentActiveMenuItem = document.querySelector('.menuiteam.active');
            const currentActiveUl = document.querySelector('.menuiteam.active > ul.active'); // Select the active ul within the active menu item

            // If there's a currently active menu item AND it's not the one we just clicked
            if (currentActiveMenuItem && currentActiveMenuItem !== parentMenuItem) {
                // Deactivate the old menu item and its ul
                currentActiveMenuItem.classList.remove('active');
                if (currentActiveUl) {
                    currentActiveUl.classList.remove('active');
                }
            }

            // Toggle the 'active' class on the clicked menu item's parent
            // This will open or close the clicked item
            if (parentMenuItem) {
                parentMenuItem.classList.toggle('active');

                // Now, target the ul within the parentMenuItem and toggle its 'active' class
                const ulToToggle = parentMenuItem.querySelector('ul');
                if (ulToToggle) {
                    ulToToggle.classList.toggle('active');
                }
            }
        });
    });

    const dropSections = document.querySelectorAll(".drop_section");

    dropSections.forEach(dropSection => {
        dropSection.addEventListener("click", e => {
            // Check if the screen width is less than or equal to 991 pixels
            if (window.innerWidth <= 991) {
                e.preventDefault(); // Prevent default behavior only on desktop (before 991px)
            }
            dropSection.classList.toggle("active_drop");
        });
    });

});

// Feature Slider Js
$('.feature_slider').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    centerMode: true,
    variableWidth: true
});

///last slider///////////////

$(window).on('load resize orientationchange', function() {
    $('.explore_collection').each(function() {
        var $carousel = $(this);
        if ($(window).width() > 575) {
            if ($carousel.hasClass('slick-initialized')) {
                $carousel.slick('unslick');
            }
        } else {
            if (!$carousel.hasClass('slick-initialized')) {
                $('.explore_collection').slick({
                    // dots: true,
                    infinite: true,
                    arrows: true,
                    slidesToShow: 2,
                    autoplaySpeed: 2000,
                    autoplay: false,
                    slidesToScroll: 1,
                    responsive: [{
                        breakpoint: 361,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                    }]
                });
            }
        }
    });
});


// --- NEW JAVASCRIPT FOR MEGA MENU RESET ---
//         document.addEventListener('DOMContentLoaded', function() {
//   const megaMenus = document.querySelectorAll('.mega_hvr_menu');
//   megaMenus.forEach(menu => {
//     menu.style.display = 'none';
//   });


//   const navItems = document.querySelectorAll('.navitem.has-dropdown');
//   navItems.forEach(item => {
//     item.addEventListener('mouseenter', function() {
//       this.querySelector('.mega_hvr_menu').style.display = 'block';
//     });
//     item.addEventListener('mouseleave', function() {
//       this.querySelector('.mega_hvr_menu').style.display = 'none';
//     });
//   });
// });